import { UserGoalView } from "@curefit/gmf-common";
import ApiUtils from "../utils/ApiUtils"
import { METRIC_SERVICE_API_PREFIX } from "../../../common/configs/configs";
import { IMetricServiceApis } from "./IMetricServiceApis";
import { IAddMetric, IMetricData, IMetricOptions } from "@curefit/metrics-common";
import { AlbusUrlConfigs } from "./AlbusUrlConfigs";
import { ILabtestPrescription } from "@curefit/care-common";
import { IGlucoseReadingsForPatientParams } from "../models/metrics/IGlucoseReadingsForPatientParams";
import { ISugarJournalResponse } from "../models/ISugarJournalResponse";
import { ISugarJournalRequest } from "../models/ISugarJournalRequest";

const saveUserMetric: string = METRIC_SERVICE_API_PREFIX + "/user-metric";
const saveDiagnosticLabTests: string = METRIC_SERVICE_API_PREFIX + "/user-metric/values"

const getGlucoseReadingsForUserUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/search"

const getCronicCareGlucoseUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/value-with-range-label";

export default class MetricServiceApis implements IMetricServiceApis {
    apiUtils: any;
    saveUserMetric(req: IAddMetric): Promise<UserGoalView[]> {
        return ApiUtils.apiPostRequest(saveUserMetric, JSON.stringify(req));
    };

    fetchUserMetric(req: IMetricOptions): Promise<IMetricData[]> {
        return ApiUtils.apiGetRequest(`${saveUserMetric}?${ApiUtils.requestToQueryParams(req)}`);

    }

    fetchStaticDiagnosticLabTests(input: string): Promise<IMetricData[]> {
        return ApiUtils.apiGetRequest(AlbusUrlConfigs.createGetLabTestsUrl(input));
    };

    savePatientDiagnosticLabTests(metric: ILabtestPrescription[]): Promise<any> {
        return ApiUtils.apiPostRequest(saveDiagnosticLabTests, JSON.stringify(metric))
    }

    fetchGlucoseReadingsForPatient(params: IGlucoseReadingsForPatientParams): Promise<any> {
        const urlParams = ApiUtils.requestToQueryParams({ ...params, source: "CMT" })
        return ApiUtils.apiGetRequest(`${getGlucoseReadingsForUserUrl}?${urlParams}`)
    }

    fetchChronicCareGlucose(params: ISugarJournalRequest): Promise<ISugarJournalResponse[]> {
        const urlParams = ApiUtils.requestToQueryParams(params);
        return ApiUtils.apiGetRequest(`${getCronicCareGlucoseUrl}?${urlParams}`)
    }

}